<template>
  <div class="home">
    <el-row id="artList" type="flex" justify="center">
      <el-col :xs="{span:24,offset:0}" :sm="{span:22,offset:0}" :md="{span:10,offset:0}">
        <div v-if="paginationShow">
          <el-row class="art-item" v-for="item in articleList" :key="item.id" :value="item">
            <el-card shadow="hover">
              <el-row class="art-info d-flex align-items-center justify-content-start">
                <el-col>
                  <h5>
                    <router-link :to="'/article/'+item.id" class="art-title">{{item.articleName}}</router-link>
                  </h5>
                </el-col>
              </el-row>
              <el-row class="art-info d-flex align-items-center justify-content-start">
                <el-col>
                  <div class="art-tag">
                    <img class="tag" src="../assets/tag.png" />：
                    <el-tag size="mini">{{queryCategoryName(item.categoryId)}}</el-tag>
                  </div>
                </el-col>
              </el-row>
              <el-row class="art-body">
                <router-link :to="'/article/'+item.id">
                  <img class="art-banner" :src="item.articleIcon" />
                </router-link>
              </el-row>
              <el-row class="art-info d-flex align-items-center justify-content-start">
                <el-col>
                  <div class="art-time">
                    <i class="el-icon-time"></i>
                    ：{{item.createTime}}
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-row>
        </div>
        <div v-else>
          <div style="text-align:center;margin-top:30px">
            <div style="display:inline-block; float:none">
              <el-pagination background layout="prev, pager, next" :current-page="1" :total="1"></el-pagination>
            </div>
          </div>
        </div>
        <div style="text-align:center;margin-top:30px">
          <div style="display:inline-block; float:none">
            <el-pagination v-if="paginationShow" ref="pagination" background layout="prev, pager, next" :current-page.sync="currentPage" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
          </div>
        </div>
      </el-col>
      <el-col :md="{span:6,offset:1}" class="hidden-sm-and-down" id="side">
        <div class="item">
          <search></search>
        </div>
        <div class="item">
          <tag></tag>
        </div>
        <div class="item">
          <friend></friend>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import friend from "../components/friend";
import tag from "../components/tag";
import search from "../components/search";
export default {
  name: "home",
  components: {
    friend,
    tag,
    search,
  },
  data() {
    return {
      currentCategoryId: 0,
      currentPage: 1,
    };
  },
  computed: {
    categoryList() {
      return this.$store.state.categoryList;
    },
    articleList() {
      return this.$store.state.articleList;
    },
    pageTotal() {
      return this.$store.state.totalArticleNum;
    },
    paginationShow() {
      return this.$store.state.articleList.length === 0 ? false : true;
    },
    searchInputString() {
      return this.$store.state.searchInputString;
    },
  },
  created() {
    this.$store.commit("queryAllLinks");
    this.$store.commit("queryCategoryInfoList");
    this.$store.commit("queryArticleList", {
      categoryId: this.currentCategoryId,
      page: this.$store.state.currentHomePage,
      searchParam: this.searchInputString,
    });
    this.$store.commit("setActiveIndex", "/home");
    this.currentPage = this.$store.state.currentHomePage;
    window.scroll(0, 0);
  },
  methods: {
    // 分页导航
    handlePageChange(val) {
      console.log(val);
      this.currentPage = val;
      this.$store.commit("queryCategoryInfoList");
      this.$store.commit("queryArticleList", {
        categoryId: this.currentCategoryId,
        page: this.currentPage,
        searchParam: this.searchInputString,
      });
      window.scroll(0, 0);
    },
    //查询分类名称
    queryCategoryName(id) {
      for (var i = 0; i < this.categoryList.length; i++) {
        if (this.categoryList[i].id === id) {
          return this.categoryList[i].categoryName;
        }
      }
      return "";
    },
  },
};
</script>

<style scoped>
#side .item {
  margin-bottom: 30px;
}

.art-item {
  margin-bottom: 30px;
  position: relative;
}

.art-item .star {
  width: 60px;
  height: 60px;
  position: absolute;
  top: 0;
  right: 0;
}

img.tag {
  width: 16px;
  height: 16px;
}

.art-title {
  padding-left: 0px;
  cursor: pointer;
  text-decoration: none;
  color: #000;
}

.art-title:hover {
  padding-left: 2px;
  color: #409eff;
}

.art-time {
  margin-right: 2px;
  text-align: right;
}

.art-tag {
  margin-right: 2px;
  text-align: right;
}

.art-body {
  display: flex;
  padding: 10px 0;
}

.side-img {
  height: 100%;
  width: 100%;
  overflow: hidden;
  margin-right: 10px;
}

img.art-banner {
  width: 100%;
  height: 100%;
}

.side-abstract {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.art-abstract {
  flex: 1;
  color: #aaa;
}

.art-more {
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.art-more .view {
  color: #aaa;
}

.pagination {
  background-color: #f9f9f9;
}
</style>